// Configuration Enums ---------------------------------------------------------------------------------------------------------------------

export enum ConfigurationFields {
  AccessKey = 'x-access-key',
  BaseUrl = 'base_url',
  BranchId = 'branch_id',
  CompanyId = 'company_id',
  ConfigurationData = 'configuration_data',
  CreatedAt = 'created_at',
  DatabaseId = 'x-database-id',
  DeploymentTypeCode = 'deployment_type_code',
  Id = 'id',
  Name = 'name',
  SecretKey = 'x-secret-key',
  Title = 'title',
  Type = 'type',
  TypeDescription = 'type_description',
  UpdatedAt = 'updated_at',
}

export enum ConfigurationType {
  AUTO_IT = 'AUTO_IT',
  PARTS_PORTAL = 'PARTS_PORTAL',
}

export enum ConfigurationDeploymentTypeCode {
  DEV = 'DEV',
  TEST = 'TEST',
  DEMO = 'DEMO',
  PILOT = 'PILOT',
  PROD = 'PROD',
}

// Configuration Constants -----------------------------------------------------------------------------------------------------------------

export const CONFIGURATION_TYPE_DEFAULT = ConfigurationType.AUTO_IT;
export const CONFIGURATION_TYPE_UNKNOWN_MESSAGE = 'Unknown Configuration type';

export const ConfigurationTypes: Record<ConfigurationType, ConfigurationTypeDescription> = {
  [ConfigurationType.AUTO_IT]: {
    [ConfigurationFields.Name]: ConfigurationType.AUTO_IT,
    [ConfigurationFields.Title]: 'Auto-IT Configurations',
  },
  [ConfigurationType.PARTS_PORTAL]: {
    [ConfigurationFields.Name]: ConfigurationType.PARTS_PORTAL,
    [ConfigurationFields.Title]: 'Parts Portal Configurations',
  },
};

// Configuration Interfaces ----------------------------------------------------------------------------------------------------------------

export interface Configuration {
  [ConfigurationFields.BranchId]: number;
  [ConfigurationFields.CompanyId]: number;
  [ConfigurationFields.CreatedAt]: string | null;
  [ConfigurationFields.ConfigurationData]: string;
  [ConfigurationFields.Id]: number;
  [ConfigurationFields.TypeDescription]: string | null;
  [ConfigurationFields.Type]: ConfigurationType | null;
  [ConfigurationFields.UpdatedAt]: string | null;
}

export interface ConfigurationCrud {
  [ConfigurationFields.BranchId]: number;
  [ConfigurationFields.CompanyId]: number;
  [ConfigurationFields.ConfigurationData]: string;
  [ConfigurationFields.Id]: number | null;
  [ConfigurationFields.TypeDescription]: string | null;
  [ConfigurationFields.Type]: ConfigurationType | null;
}

export interface ConfigurationTypeDescription {
  [ConfigurationFields.Name]: ConfigurationType;
  [ConfigurationFields.Title]: string;
}

export interface ConfigurationDetail {
  [ConfigurationFields.BranchId]: number;
  [ConfigurationFields.CompanyId]: number;
  [ConfigurationFields.CreatedAt]: string | null;
  [ConfigurationFields.Id]: number;
  [ConfigurationFields.ConfigurationData]: string;
  [ConfigurationFields.Type]: ConfigurationType | null;
  [ConfigurationFields.TypeDescription]: string | null;
  [ConfigurationFields.UpdatedAt]: string | null;
}

export interface ConfigurationDetailAutoIt {
  [ConfigurationFields.AccessKey]: string;
  [ConfigurationFields.BaseUrl]: string;
  [ConfigurationFields.DatabaseId]: number;
  [ConfigurationFields.DeploymentTypeCode]: string;
  [ConfigurationFields.SecretKey]: string;
}
